import classNames from "classnames";

import { getConditionTagColor } from "../../../util/flagSummaryUtils";
import styles from "./styles.module.scss";

/**
 * ui2026 condition tag. Same shape as the Compassus side peek / visits tags
 * (Circular-Book 12px, 4px radius, soft tint + border) rather than antd's
 * preset colours. The colour family still comes from the condition type.
 */

type Tone =
  | "red"
  | "blue"
  | "amber"
  | "green"
  | "violet"
  | "pink"
  | "teal"
  | "grey";

const TONE_BY_ANTD_COLOR: Record<string, Tone> = {
  red: "red",
  volcano: "amber",
  orange: "amber",
  gold: "amber",
  blue: "blue",
  geekblue: "blue",
  green: "green",
  success: "green",
  purple: "violet",
  magenta: "violet",
  pink: "pink",
  cyan: "teal",
};

export const conditionTone = (condition: string): Tone =>
  TONE_BY_ANTD_COLOR[getConditionTagColor(condition)] ?? "grey";

const ConditionTag = ({
  condition,
  className,
}: {
  condition: string;
  className?: string;
}) => (
  <span
    className={classNames(
      styles.tag,
      styles[`tone_${conditionTone(condition)}`],
      className
    )}
    title={condition}
  >
    {condition}
  </span>
);

export const ConditionTagList = ({
  conditions,
  className,
}: {
  conditions: string[];
  className?: string;
}) =>
  conditions.length ? (
    <div className={classNames(styles.list, className)}>
      {conditions.map((condition, index) => (
        <ConditionTag key={`${condition}-${index}`} condition={condition} />
      ))}
    </div>
  ) : null;

export default ConditionTag;
